import React, { useMemo } from 'react';

import { DerivativesOpenedPositionProjection } from 'common/api/autogenerated/trading-gateway';

import { useDerivativesPositions } from 'common/hooks';
import { ModalAction } from 'common/redux/modal/initialState';

import DerivativeDashboardProvider from 'views/derivatives/dashboard/DerivativeDashboard.provider';

import CloseDerivativePositionPopup from './CloseDerivativePositionPopup.component';

export interface CloseDerivativePositionPopupProps extends ModalAction {
  id: DerivativesOpenedPositionProjection['id'];
  onCancel?: () => void;
}

export const PartiallyCloseDerivativePositionPopup: React.FC<
  React.PropsWithChildren<CloseDerivativePositionPopupProps>
> = (props) => {
  const { id } = props;

  const { positions } = useDerivativesPositions();

  const position = useMemo(() => positions.find((i) => Number(i.id) === Number(id)), [id, positions]);
  const code = useMemo(() => String(position?.tradingPairCode), [position?.tradingPairCode]);

  if (!position) return null;

  const [base, quoted] = (position?.tradingPairCode || '').split('-');

  return (
    <DerivativeDashboardProvider base={base} quoted={quoted} code={code}>
      <CloseDerivativePositionPopup {...props} />
    </DerivativeDashboardProvider>
  );
};
